import { ReactComponent as BigChipIcon } from 'src/assets/icons/big-chip-icon.svg';

export const Currency = ({
  currency,
  inlineBlock = true,
}: {
  currency: string;
  inlineBlock?: boolean;
}) => {
  if (currency === '🪙') {
    return (
      <span
        style={{
          display: inlineBlock ? 'inline-block' : 'inherit',
          verticalAlign: 'middle',
          marginRight: '0.15em',
        }}
      >
        <BigChipIcon style={{ width: '1em', height: '1em' }} />
      </span>
    );
  }

  return <>{currency}</>;
};
